import Dialog from 'bui/presenters/dialog'
import { html, LitElement } from 'lit'
import './includes'
import dayjs from 'dayjs'
import apifetch from './apifetch'
import Sessions, {Result} from './models'
import './section/sessions'
import './section/camper'
import './section/emergency'
import './section/guardian'
import './section/medical'
import './section/background'
import { GetStripeToken, TEST_CARD, TEST_MODE } from './stripe'
import WaiverView from './waiver'
import ConfirmView from './confirm'
import MedFormView from './med-form'

const STORE_KEY = '2025-registration'

const OPTIONAL = ['returning_camper', 'weight', 'vegetarian', 'gluten_free', 'parent_phone_home', 'parent_phone_cell', 'different_address', 'emerg_phone', 'emerg_cell', 'parent_as_emerg', 'coupon', 'height_in', 'fav_memory', 'medical_cpr', 'shoe']

const CAMPER_NOT_NEEDED = ['medical_cpr', 'employer', 'employer_contact', 'employer_phone', 'bgd_check']

const ADULT_NOT_NEEDED = ['parent_name', 'parent_email', 'parent_phone_home', 'parent_phone_cell', 'parent_address', 'parent_city', 'parent_state', 'parent_zip', 'parent_as_emerg', 'coach', 'consent_minor']

const STAFF_NOT_NEEDED = ['height_ft', 'height_in', 'weight', 'grade', 'returning_camper', 'deposit']

const OPTIONAL_PARENT = ['parent_address', 'parent_city', 'parent_state', 'parent_zip']

const OPTIONAL_EMERG = ['emerg_name', 'emerg_relationship', 'emerg_address', 'emerg_phone', 'emerg_cell']


customElements.define('steens-registration', class extends LitElement{
	
	constructor(){
		super()

		window.sr = this // TEMP

		this.result = new Result()
		this.sessions = new Sessions()
	}

	firstUpdated(){
		
		let session = this.getAttribute('session')
		this.sessions.fetchSync({data: {num: session}}).then(_=>{
			if( this.sessions.length == 1 ){
				let model = this.sessions.first()
				if( model.isAvailable )
					this.changeSession({detail: {model}})
			}
				
		})

		setTimeout(()=>{
			this.validateCoupon()

			if( TEST_MODE && TEST_CARD ){

				for( let k in TEST_CARD ){
					if( this.formHandler.get(k) )
						this.formHandler.get(k).value = TEST_CARD[k]
				}

			}

			this.result.set(this.formHandler.values)
		})
	}

	createRenderRoot(){ return this }

	render(){return html`

		<form-handler store="${STORE_KEY}" .model=${this.result} .validateChange=${this.validateChange.bind(this)}>

			<steens-form-section-sessions 
				.coll=${this.sessions}
				.model=${this.model}
				@change-session=${this.changeSession}
			></steens-form-section-sessions>

			<steens-form-section-camper></steens-form-section-camper>
			<steens-form-section-medical @fill-med-form=${this.fillMedForm}></steens-form-section-medical>
			<steens-form-section-guardian ?hidden=${this.isAdult}></steens-form-section-guardian>
			<steens-form-section-emergency></steens-form-section-emergency>

			<steens-form-background ?hidden=${!this.result.isStaff}></steens-form-background>

			<b-paper id="payment" ?hidden=${!this.model?.requiresCreditCard}>
				
				<header><b-flex>
					<h3>💵 Payment</h3>
	
					<b-text lg color="theme" bold>
						$${this.model?.get('rate')}
					</b-text>

				</b-flex></header>

				<div>
					<div class="cc">

						<form-control material="filled" key="cc_number" label="Debit / Credit Card">
							<input slot="control" type="text" autocomplete="cc-number" pattern='[0-9]*'>
						</form-control>

						<form-control material="filled" key="cc_exp_month" label="MM">
							<input slot="control" type="number" maxlength="2" minlength="1" pattern='[0-9]*' autocomplete="cc-exp-month">
						</form-control>

						<form-control material="filled" key="cc_exp_year" label="YYYY">
							<input slot="control" type="number" maxlength="4" minlength="4" pattern='[0-9]*' autocomplete="cc-exp-year">
						</form-control>

						<form-control material="filled" key="cc_cvc" label="CSC">
							<input slot="control" maxlength="4" minlength="" pattern='[0-9]*' type="number" autocomplete="cc-csc">
						</form-control>

					</div>
				</div><br>


				<b-grid cols=4 cols-mobile=2>

					<form-control material="filled" key="deposit" label="Deposit Amt" style="width:300px" prefix="$">
						<input slot="control" type="number" value="${this.model?.get('deposit')}">
						<span slot="suffix">of $${this.model?.get('rate')}</span>
						<b-text slot="help" ?hidden=${!this.model?.get('discount')} _color="blue">
							Family/Team discount: $${this.model?.get('discount')}</b-text>
					</form-control>

					<form-control material="filled" key="coupon" label="Coupon" style="width:300px">
						<text-field></text-field>
					</form-control>

				</b-grid>

				<b-paper style="margin:1em 0 0;" dense color="info" outline ?hidden=${!this._coupon||this._coupon.action!='pay-by-grant'}>
					<b-label filled="blue">${!this._coupon||this._coupon.coupon}</b-label> 
					Your card will not be charged a deposit upon registration. The Steens Grant will be applied to  your deposit/balance. If a balance still exists, you will be invoiced for the remaining camp fee.
				</b-paper>

				<b-paper style="margin:1em 0 0;" dense color="info" outline ?hidden=${!this._coupon||this._coupon.action!='pay-by-snailmail'}>
					<b-label filled="blue">${!this._coupon||this._coupon.coupon}</b-label> 
					Your card will not be charged upon registration in the expectation you will mail us check or cash for a minimum deposit of $${this.model?.get('deposit')}. We <b>MUST</b> receive your mailed deposit with <b>seven (7) days</b> of application or your registration will be cancelled. Please make checks out to: <b>Steens Mt. Running Camp</b> Mail to: <b>PO BOX 5453 Eugene, OR 97405</b>
				</b-paper>

				<b-paper style="margin:1em 0 0;" dense color="info" outline ?hidden=${!this._coupon||this._coupon.action!='pay-by-coach'}>
					<b-label filled="blue">${!this._coupon||this._coupon.coupon}</b-label> 
					Your card will not be charged a deposit upon registration. If School/Coach fails to pay the mutually agreed upon deposit/fees, you will be invoiced for the full camp fee.
				</b-paper>

				<ul>
					<li>
						<b>A $${this.model?.get('deposit')} minimum deposit</b> paid at time of registration reserves a spot for camper.
					</li>
					<li>
						<b>Final invoice</b> with your remaining blance will be sent in <b>early June</b>. There will be a link for you to pay the remainder online.
					</li>
					<li>
						<b>Discounts</b> will be applied at the time of invoice in June.
					</li>
					<li>
						<b>Cancelation: </b> <i>Need to cancel?</i> <a href="mailto:hello@steens.camp?subject=Cancellation request&body=Please cancel: __">Email us</a> before <b>June 15th</b> for a full refund.
					</li>
				</ul>

				${this.model?.get('num')==3?'':html`
				<p><b-text color="blue" bold>Is your team fundraising?</b-text> 
				<br>You (or a parent/coach) can bring cash/check for one or more campers on the first day of camp.</p>
				`}

				<p><i>Any remaining balance after check-in at Burns will be charged to the card on file from initial registration.</i></p>

			</b-paper>

			<b-paper id="risk" ?hidden=${!this.didReadWaiver}>
				<section>

					<b-btn @click=${this.readWaiver} block color="theme" lg>Read Risk Agreement</b-btn>

					<div>
					<br>
					${this.isAdult?html`
					<div>I have carefully read the foregoing agreement and understand its contents. I am aware that I am releasing certain legal rights I might otherwise may have. I agree to be fully bound by the terms of this agreement.</div>
					`:html`
					<h3>PARENT/LEGAL GUARDIAN:</h3>

					<div>I have carefully read the foregoing agreement and understand its contents. I am aware that I am releasing certain legal rights that my minor child otherwise may have. I agree to be fully bound by the terms of this agreement.</div>
					`}

					<div>
						<br>
						<check-box type="switch" key="consent" label="I agree"></check-box>
						<br><br>
					</div>

					<form-control material="filled" key="consent_email" label="Email" style="display:block;">
						<input slot="control" type="email" reset-invalid autocomplete="section-consent email">
						<span slot="help">
							${this.isAdult?html`
							This email further identifies my agreement to the risk agreement
							`:html`
							This email further identifies me as the signatory and  responsible parent/guardian of the minor camper
							`}
						</span>
					</form-control>

					<b-text ?hidden=${this.isAdult}>
						<br>
						<h3>MINOR PARTICIPANT (under 18 years of age):</h3>

						<div>I have read the list of inherent risks in paragraph 1 of this agreement and have discussed the same with my parent or legal guardian. I assume the risk of injury or death resulting from my participation in smrc programs, and pursuant to paragraph 2 of this agreement, to the fullest extent permitted by oregon law. I have reviewed paragraph 3 of this agreement and understand and agree with the responsibilities and representations set forth in that paragraph.</div>

						<div>
							<br>
							<check-box type="switch" key="consent_minor" label="I agree"></check-box>
						</div>
					</b-text>

					</div>

				</section>
			</b-paper>
			
		

		<b-btn ?hidden=${this.didReadWaiver} @click=${this.readWaiver} block color="theme" lg>Read Risk Agreement</b-btn>
		
		<b-btn ?hidden=${!this.didReadWaiver} lg @click=${this.submit} pill color="primary">Review</b-btn>

		</form-handler>
	`}

	changeSession(e){
		this.model = e.detail.model

		if( !this.model.isAvailable )
			throw new UIWarningError('That session is not available', {target: e.currentTarget})

		this.setAttribute('sessionpicked', '')
		this.formHandler.get('deposit').value = this.model.get('deposit')
		this.result.set('session', this.model.get('num')) // NOTE: or should it be the model?

		document.documentElement.style.setProperty('--theme', this.model.get('num')=='3'?'var(--blue)':'var(--green)')
	}

	readWaiver(){
		WaiverView.shared.open({
			version: this.result.isStaff ? 'staff' : (this.result.isAdult ? 'adult' : 'default'),
			onClose:e=>{
				this.didReadWaiver = true
				this.update()
			}
		})
	}

	async validateChange(m, changes, key, val){

		if( key == 'deposit' ){
			if( val < this.model.get('deposit') ){
				changes[key] = this.model.get('deposit')
				return false
			}

			let rate = this.model.get('rate')

			if( val > rate ){
				changes[key] = rate
				return false;
			}
		}

		if( key == 'coupon' ){
			if( !val ){
				delete this._coupon
			}else{
				return this.validateCoupon(val, changes)
			}
		}

		if( key == 'dob' ){

			if( this.isAdult )
				changes.parent_as_emerg = false

			this.requestUpdate()
		}
	}

	async validateCoupon(val, changes=[]){
		let control = this.formHandler.get('coupon')

		if( val === undefined )
			val = control.value

		let resp = val ? await apifetch('/registration/validate-coupon/'+val) : null
		
		if( resp && resp.valid )
			this._coupon = resp
		else{
			delete this._coupon
			control.value = ''
			changes['coupon'] = ''
			this.update()
			return false
		}

		this.update()
	}

	get medForm(){
		return MedFormView.shared // remove
	}

	fillMedForm(e){
		MedFormView.shared.open(this.model, this.result)
	}

	get formHandler(){
		return this.querySelector('form-handler')
	}

	get isAdult(){
		
		return this.result.isAdult
		// if( this.model?.get('num') == 3 ) return true;

		let dob = this.formHandler?.get('dob')?.value
		return dob && Math.abs(dayjs(dob).diff(new Date, 'year')) >= 18
	}
	
	async submit(e){
		let btn = e.currentTarget

		if( btn.spin ) return

		let data = {
			sid: this.model.id,
			session: this.model.get('num'),
			rate_amt: this.model.get('rate'),
			certs: this.result.get('certs')
		}

		let diffParentAddr = this.formHandler.get('different_address').value
		let parentAsEmerg = this.formHandler.get('parent_as_emerg').value
		let isAdult = this.isAdult
		let isStaff = this.result.isStaff
		let requiresCreditCard = this.model.requiresCreditCard

		this.formHandler.editors.forEach(c=>{

			// dont collection empty keys or credit card info
			if( !c.key || c.key.match(/^cc_/) ) return
			
			data[c.key] = c.value

			if( !c.value ){

				if( OPTIONAL.includes(c.key)
				|| (!isStaff && CAMPER_NOT_NEEDED.includes(c.key))
				|| (isAdult && ADULT_NOT_NEEDED.includes(c.key) )
				|| (isStaff && STAFF_NOT_NEEDED.includes(c.key))
				|| (!diffParentAddr && OPTIONAL_PARENT.includes(c.key))
				|| (parentAsEmerg && OPTIONAL_EMERG.includes(c.key)) ){
					return
				}

				c.scrollIntoView()
				
				console.log(c);
				
				if( c.checkVisibility?.() )
					throw new UIDeniedError('required', {target: c})
				else
					throw new UIDeniedError('Required: '+c.value)
			}
		})

		if( this._coupon && ['pay-by-coach', 'pay-by-snailmail'].includes(this._coupon.action) )
			data.deposit = 0

		data.balance = data.rate_amt - data.deposit

		let medHistory = this.model.get('medform')
		
		if( !medHistory.isComplete ){
			this.fillMedForm()
			return
		}else{
			data.medical_history = medHistory.value
		}

		if( !TEST_MODE && !isAdult && !data.parent_phone_home && !data.parent_phone_cell ){
			throw this.errorNotif('parent_phone_home', {msg: 'A phone number is needed'})
		}

		if( !TEST_MODE && !parentAsEmerg && !data.emerg_phone && !data.emerg_cell ){
			throw this.errorNotif('emerg_phone', {msg: 'A phone number is needed'})
		}

		delete data.different_address
		
		let cardData = {
			number: this.formHandler.get('cc_number').value,
			cvc: this.formHandler.get('cc_cvc').value,
			exp_month: this.formHandler.get('cc_exp_month').value,
			exp_year: this.formHandler.get('cc_exp_year').value
		}

		if( requiresCreditCard ){

			for( let key in cardData ){
				if( !cardData[key] )
					throw this.errorNotif('cc_number', {msg: 'Credit Card required'})
			}

			let token = null

			btn.spin = true
			
			try{
				token = await GetStripeToken(cardData)
				btn.spin = false
			}catch(err){
				btn.spin = false
				console.log(err);
				throw this.errorNotif('cc_number', {msg: err.message})
			}

			data.token = token.id
		}

		if( TEST_MODE )
			console.log(data);

		ConfirmView.shared.open(data, this.model, this.result, ()=>{

			let resetVals = {
				name: '',
				email: '',
				height_ft:'',
				height_in:'',
				weight: '',
				grade: '',
				dob: '',
				shirt: '',
				shoe: '',
				consent: '',
				consent_email: '',
				consent_minor: '',
				returning_camper: null,
				vegetarian: false,
				gluten_free: false
			}

			// clear camper values (keep others in tact)
			if( !TEST_MODE ){
				this.formHandler.store(resetVals)
				this.result.set(resetVals)
			}

			// also clear med form
			if( !TEST_MODE )
				MedFormView.shared.clear()
			
			Dialog.success({
				title: 'Success',
				msg: 'You’re registered. You should be receiving a confirmation email shortly'
			}).modal({width: '400px'})

			document.body.parentElement.scrollTop = 0
			this.formHandler._updateEditors()
		})
	}

	errorNotif(key, msg){
		let el = this.formHandler.get(key)
		// el.scrollIntoView()
		return new UIDeniedError(msg.msg, {target: el})
		// Dialog.error(Object.assign(msg, {btns: false, color: ''})).popOver(el)
	}
	
})